// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a0PA","col":"styles_col__3SZYW"};